import { fmtNum } from "@/lib/format";

const COLOR = { ON_TRACK: ["#34D399", "#059669"], AT_RISK: ["#FBBF24", "#D97706"], CRITICAL: ["#FB7185", "#E11D48"] };
const LABEL = { ON_TRACK: "On track", AT_RISK: "At risk", CRITICAL: "Critical" };
const band = (s) => (s >= 66 ? "High" : s >= 33 ? "Medium" : "Low");

export function DelayRiskChart({ projects, onOpen }) {
  const rows = [...projects].sort((a, b) => (b.risk_score || 0) - (a.risk_score || 0));
  return (
    <div className="space-y-4" data-testid="delay-risk-chart">
      <div className="space-y-3">
        {rows.map((p) => {
          const score = Math.max(0, Math.min(100, Number(p.risk_score) || 0));
          const [from, to] = COLOR[p.health] || COLOR.AT_RISK;
          return (
            <button key={p.project_id || p.code} type="button" onClick={() => onOpen && p.project_id && onOpen(p.project_id)}
              className="group grid w-full grid-cols-[minmax(84px,160px)_1fr_auto] items-center gap-3 rounded-lg px-2 py-1.5 text-left transition-colors hover:bg-accent/40">
              <div className="min-w-0">
                <div className="truncate font-mono text-xs font-semibold text-foreground">{p.code}</div>
                {p.name && <div className="truncate text-[11px] text-muted-foreground">{p.name}</div>}
              </div>
              <div className="relative h-3.5 overflow-hidden rounded-full bg-muted/60">
                <div className="absolute inset-y-0 left-[33%] w-px bg-border" />
                <div className="absolute inset-y-0 left-[66%] w-px bg-border" />
                <div className="h-full rounded-full transition-[width] duration-500"
                  style={{ width: `${Math.max(score, score > 0 ? 2 : 0)}%`, background: `linear-gradient(90deg, ${from}, ${to})`, boxShadow: `0 0 12px ${to}55` }} />
              </div>
              <div className="flex items-center gap-2 whitespace-nowrap">
                <span className="w-10 text-right text-sm font-semibold tabular-nums text-foreground">{fmtNum(score, 1)}</span>
                <span className="rounded-full px-2 py-0.5 text-[11px] font-medium text-white" style={{ background: to }}>{LABEL[p.health] || band(score)}</span>
              </div>
            </button>
          );
        })}
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 border-t border-border pt-3 text-[11px] text-muted-foreground">
        <span>Scale 0 to 100 · markers at 33 (medium) and 66 (high)</span>
        <span className="flex items-center gap-3">
          {Object.entries(LABEL).map(([k, v]) => (
            <span key={k} className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: COLOR[k][1] }} />{v}</span>
          ))}
        </span>
      </div>
    </div>
  );
}
